import { authConsts } from "../types/auth";
import {
  OrganizacjaWidok,
  OrganizacjeAction,
  organizacjeConsts,
} from "../types/organizacje";

export interface OrganizacjeState {
  lista: OrganizacjaWidok[];
  browseError: string;
  editError: string;
  wybrana: OrganizacjaWidok;
  zaproszenieError: string;
}

const initialState: OrganizacjeState = {
  lista: [],
  browseError: "",
  editError: "",
  wybrana: {} as OrganizacjaWidok,
  zaproszenieError: "",
};

export default function organizacje(
  state = initialState,
  action: OrganizacjeAction
): OrganizacjeState {
  switch (action.type) {
    case organizacjeConsts.PRZEGLADAJ_ORGANIZACJE_SUCCESS:
      return { ...state, lista: action.lista, browseError: "" };
    case organizacjeConsts.DODAJ_ORGANIZACJE_SUCCESS:
    case organizacjeConsts.EDYTUJ_ORGANIZACJE_SUCCESS:
      return { ...state, editError: "" };
    case organizacjeConsts.DODAJ_ORGANIZACJE_FAILURE:
    case organizacjeConsts.EDYTUJ_ORGANIZACJE_FAILURE:
      return { ...state, editError: action.error };
    case organizacjeConsts.PRZEGLADAJ_ORGANIZACJE_FAILURE:
    case organizacjeConsts.USUN_ORGANIZACJE_FAILURE:
    case organizacjeConsts.DAJ_WYBRANA_ORGANIZACJE_FAILURE:
    case organizacjeConsts.ZMIEN_WYBRANA_ORGANIZACJE_FAILURE:
      return { ...state, browseError: action.error };
    case organizacjeConsts.DAJ_WYBRANA_ORGANIZACJE_SUCCESS:
    case organizacjeConsts.ZMIEN_WYBRANA_ORGANIZACJE:
      return { ...state, wybrana: action.wybrana };
    case organizacjeConsts.DAJ_ZAPROSZENIE_FAILURE:
    case organizacjeConsts.ODRZUC_ZAPROSZENIE_FAILURE:
    case organizacjeConsts.POTWIERDZ_ZAPROSZENIE_FAILURE:
      return { ...state, zaproszenieError: action.error };
    case authConsts.LOGOUT:
      return initialState;
    default:
      return state;
  }
}
